/**
 * 新开业培训
 * @description 新开业培训新增、编辑
 * @author xyguo
 * @date 2021-3-12
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Cascader, InputNumber } from 'antd'
import { component_tool, framework_tool } from '@/tool'
import $$ from 'cmn-utils';
import "./index.less";
let {
    WizButton,
    WizSelect,
    WizTooltip,
    WizInput,
    WizIcon,
    WizSwitch,
    WizLocationSelect,
    WizRow,
    WizCol,
    WizRadio,
    WizDivider,
    WizCheckbox,
    WizInputNumber
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option
let OptGroup = WizSelect.OptGroup
import { WizTableForm, WizAuthority } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, organizationNodeCategory: ["2"] } })
const positionConfig = WizTableForm.Config.positionName(this, { apiParams: { state: 1 } })
const pathStage = WizTableForm.Config.pathStage(this, { apiParams: { state: 2 } })
const cert = WizTableForm.Config.cert(this, { apiParams: { state: 1,type:1 } })
const offlineProgram = WizTableForm.Config.offlineProgram(this, { apiParams: { status: 1 } })
const exam = {...WizTableForm.Config.exam(this, { apiParams: { status: 1 } })}
const path = WizTableForm.Config.path(this, { apiParams: {  state: 2} })

const onlineProgram =  WizTableForm.Config.program(this, { apiParams: { status: 1 } })

/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class RequirementForm extends Component {

    constructor(props) {
        super(props);
        const {oldNewShop} = props.data
        this.state = {
            date: new Date().getTime(),
            configCountShow : !oldNewShop
        }
    }

    componentDidMount() {
    }

    _renderOption(){
        let rows = [{ code: 1, codeName: '4S网点' },
        { code: 2, codeName: '直营店' },
        { code: 3, codeName: '单一售后' },
        { code: 4, codeName: '单一销售' },
        { code: 5, codeName: '卫星店/直营店' },
        { code: 6, codeName: '自修站' },
        { code: 7, codeName: '卫星店' },
        { code: 8, codeName: '精品店' },
        { code: 9, codeName: 'dealer' },
        { code: 10, codeName: '4S店' },
        { code: 11, codeName: '汽车零售' },
        { code: 12, codeName: '单一销售展厅' },
        { code: 13, codeName: 'NEV单一售后' },
        { code: 14, codeName: '轻量化4S网点' },
        { code: 15, codeName: 'NEV专区' },
        { code: 16, codeName: '商超店' },
          { code: 17, codeName: '自修店' },
          { code: 18, codeName: '二级网点' },
          { code: 19, codeName: '车工坊C1' },
          { code: 20, codeName: '车工坊C2' },
          { code: 21, codeName: '车工坊B' },
          { code: 22, codeName: '德科品牌授权经销商' },
        { code: 99, codeName: '暂定' },
        { code: 0, codeName: '无' }]

        let options = []
        rows.forEach(row=>{
            let option =
                <WizSelect.Option key={'option' + row['code']} value={row['codeName']} title={row['codeName']}>
                    {row['codeName']}
                </WizSelect.Option>
            options.push(option);
        })
        return (
            options
          )

    }

    /**
     * 表单基础内容
     */
    _base() {
        const { data, form } = this.props;
        let { getFieldDecorator } = form;
        return [
            <Item label="组织" >
                {getFieldDecorator('orgId', {
                    rules: [{ required: true, message: '请选择组织' }],
                    initialValue: data[`orgId`] || null,
                })(
                    <WizTableForm
                        {...organizationConfig}
                        key={'orgId' + "@" + this.state.date}
                        selectType={'radio'}
                        initRows={data[`orgId`] ? [{ id: data[`orgId`], name: data[`orgName`] }] : []}
                    />
                )}
            </Item>,
            <Item label="岗位" >
                {getFieldDecorator('positionIds', {
                    rules: [{ required: true, message: '请选择岗位' }],
                    initialValue: data[`positionIdList`] || null,
                })(
                    <WizTableForm
                        {...positionConfig}
                        key={'positionId' + "@" + this.state.date}
                        initRows={data[`positionInfos`]&&data[`positionInfos`].length ? data[`positionInfos`] : []}
                    />
                )}
            </Item>,
          <Item label="岗位所属分类">
            {getFieldDecorator('positionCategoryList', {
              // rules: [{ required: true, message: '请选择站点类型' }],
              initialValue: data.positionCategoryList ? data.positionCategoryList : [],
            })(
              <WizCheckbox.Group>
                <WizRow>
                  <WizCol span={6}>
                    <WizCheckbox value={1} >销售</WizCheckbox>
                  </WizCol>
                  <WizCol span={6}>
                    <WizCheckbox value={2} >售后</WizCheckbox>
                  </WizCol>
                </WizRow>
              </WizCheckbox.Group>,
            )}
          </Item>,
<Item label="站点类型">
{getFieldDecorator('dealerTypeList', {
    rules: [{ required: true, message: '请选择站点类型' }],
    initialValue: data.dealerTypeList ? data.dealerTypeList : [],
})(
//     <WizSelect
//     key={'wizSelect_' + data.key+new Date().getTime()}
//     placeholder={'请选择站点类型' }
//     style={{ width: '80%' }}
//     mode = "multiple"
//   >
//     {this._renderOption()}
//   </WizSelect>

    <WizCheckbox.Group>
        <WizRow>
            <WizCol span={6}>
            <WizCheckbox value={1} >4S网点</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={2} >直营店</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={3} >单一售后</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={4} >单一销售</WizCheckbox>
            </WizCol>
        </WizRow>
        <WizRow>
            <WizCol span={6}>
            <WizCheckbox value={5} >卫星店/直营店</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={6} >自修站</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={7} >卫星店</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={8} >精品店</WizCheckbox>
            </WizCol>
        </WizRow>
        <WizRow>
            <WizCol span={6}>
            <WizCheckbox value={9} >dealer</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={10} >4S店</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={11} >汽车零售</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={12} >单一销售展厅</WizCheckbox>
            </WizCol>
        </WizRow>
        <WizRow>
            <WizCol span={6}>
            <WizCheckbox value={13} >NEV单一售后</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={14} >轻量化4S网点</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={15} >NEV专区</WizCheckbox>
            </WizCol>
            <WizCol span={6}>
            <WizCheckbox value={0} >无</WizCheckbox>
            </WizCol>
        </WizRow>
        <WizRow>
            <WizCol span={6}>
            <WizCheckbox value={16} >商超店</WizCheckbox>
            </WizCol>
          <WizCol span={6}>
            <WizCheckbox value={17} >自修店</WizCheckbox>
          </WizCol>
          <WizCol span={6}>
            <WizCheckbox value={18} >二级网点</WizCheckbox>
          </WizCol>
          <WizCol span={6}>
            <WizCheckbox value={19} >车工坊C1</WizCheckbox>
          </WizCol>
        </WizRow>
      <WizRow>
        <WizCol span={6}>
          <WizCheckbox value={20} >车工坊C2</WizCheckbox>
        </WizCol>
        <WizCol span={6}>
          <WizCheckbox value={21} >车工坊B</WizCheckbox>
        </WizCol>
        <WizCol span={6}>
          <WizCheckbox value={22} >德科品牌授权经销商</WizCheckbox>
        </WizCol>
        <WizCol span={6}>
          <WizCheckbox value={23} >单一销售展厅(专区)</WizCheckbox>
        </WizCol>
      </WizRow>
      <WizRow>
        <WizCol span={6}>
          <WizCheckbox value={24} >单一销售展厅(商超)</WizCheckbox>
        </WizCol>
      </WizRow>
    </WizCheckbox.Group>,
)}
</Item>,
            <Item label="新店/老店">
                {getFieldDecorator('oldNewShop', {
                    rules: [{ required: true,message: "请选择新店/老店" }],
                    initialValue: data.oldNewShop
                })(
                    // <WizRadio.Group>
                    //     <WizRadio value={1}>新店</WizRadio>
                    //     <WizRadio value={2}>老店</WizRadio>
                    // </WizRadio.Group>,
                    <WizSelect
                    placeholder="请选择新店/老店"
                    onSelect={(value)=>{
                        if(value==1){
                            this.setState({
                                configCountShow : false
                            })
                        }else{
                            this.setState({
                                configCountShow : true
                            })
                        }
                    }}
                >
                    <Option value={0}>新店</Option>
                    <Option value={1}>老店</Option>
                </WizSelect>,
                )}
            </Item>,
            this.state.configCountShow?
            <Item label="最低配置">
                {getFieldDecorator('configCount', {
                    rules: [
                        { required: this.state.configCountShow, message: "请输入最低配置" },
                        { pattern: /^[0-9]{1,3}$/, message: "限制输入0-100的整数" }
                    ],
                    initialValue: data.configCount
                })(
                   <WizInputNumber min={0} max={100} precision={0} />
                  ,
                )}
            </Item>:<></>,

            <Item label="考核要求">
                {getFieldDecorator('type', {
                    rules: [{ required: true, message: '请选择考核要求' }],
                    initialValue: data.types ? data.types : [],
                })(
                    <WizCheckbox.Group>
                        <WizRow>
                            <WizCol span={4}>
                            <WizCheckbox value={0} >路径阶段</WizCheckbox>
                            </WizCol>
                            <WizCol span={4}>
                            <WizCheckbox value={1} >认证</WizCheckbox>
                            </WizCol>
                            <WizCol span={4}>
                            <WizCheckbox value={2} >线下课程</WizCheckbox>
                            </WizCol>
                            <WizCol span={4}>
                            <WizCheckbox value={3} >人员测评</WizCheckbox>
                            </WizCol>
                            <WizCol span={4}>
                            <WizCheckbox value={9} >岗位认证</WizCheckbox>
                            </WizCol>
                            <WizCol span={4}>
                            <WizCheckbox value={11} >在线课程</WizCheckbox>
                            </WizCol>
                        </WizRow>
                        <WizRow>
                            <WizCol span={4}>
                            <WizCheckbox value={5} >个人简历</WizCheckbox>
                            </WizCol>
                            <WizCol span={4}>
                            <WizCheckbox value={6} >性格测试</WizCheckbox>
                            </WizCol>
                            <WizCol span={4}>
                            <WizCheckbox value={7} >面试结果</WizCheckbox>
                            </WizCol>
                            <WizCol span={4}>
                            <WizCheckbox value={8} >电工证</WizCheckbox>
                            </WizCol>
                            <WizCol span={4}>
                            <WizCheckbox value={10} >在线考试</WizCheckbox>
                            </WizCol>
                        </WizRow>
                    </WizCheckbox.Group>,
                )}
            </Item>,

            <Item label="状态">
                {getFieldDecorator('status', {
                    rules: [{ required: true, }],
                    initialValue: data.status === 0 ? data.status : 1
                })(
                    <WizRadio.Group>
                        <WizRadio value={1}>有效</WizRadio>
                        <WizRadio value={0}>无效</WizRadio>
                    </WizRadio.Group>,
                )}
            </Item>,

        ]
    }
    handleReset = () => {
        //重置表单
        this.setState({
            date: new Date().getTime(),
            output99 : undefined
        })
        this.props.form.resetFields();
    };

    /**
     * 表单提交按钮
     */
    _submit() {
        return (
            <Item wrapperCol={{ span: 12, offset: 6 }}>
                <WizRow>
                    <WizCol span={24} style={{ textAlign: 'center' }}>
                        <WizButton type="primary" htmlType="submit">
                            保存
                        </WizButton>
                        <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                            重置
                        </WizButton>
                    </WizCol>
                </WizRow>
            </Item>
        )
    }

    /**
     * 拓展属性
     */
    _ext = (type = []) => {
        const { data, form } = this.props;
        let trainPathIdInit;
        if (data && data.requirementContents && data.requirementContents.length > 0) {
            data.requirementContents.forEach(element => {
                if(element.type === 99){
                    trainPathIdInit = element.entityId
                }
            });
        }
        let r = [<></>]
        if (type.length > 0) {
            r.push(this._dividerName('考核要求设置'))
            if (type.findIndex(par => par === 0) != -1) {
                let infoPath = this._outPutType('路径', '99');
                //r.push(this._outPutType('路径', '99'))
                let trainPathId = this.state['output99'] && this.state['output99'][0] && this.state['output99'][0].id
                let apiTypePathStage = WizTableForm.Config.stage(this, { apiParams: { state: 2,trainPathId:trainPathId ? trainPathId:trainPathIdInit  } })
                let infoStage = this._outPutType('路径阶段', '0',apiTypePathStage)
                r.push(<WizRow>
                    <WizCol span={12}>{infoPath}</WizCol>
                    <WizCol span={12}>{infoStage}</WizCol>
                </WizRow>)
                r.push(this._extOpther())
            }
            if (type.findIndex(par => par === 1) != -1) {
                r.push(this._outPutType('认证', '1'))
            }
            if (type.findIndex(par => par === 2) != -1) {
                r.push(this._outPutType('线下课程', '2'))
            }
            if (type.findIndex(par => par === 10) != -1) {
                r.push(this._outPutType('在线考试', '10'))
            }
            if (type.findIndex(par => par === 11) != -1) {
                r.push(this._outPutType('在线课程', '11'))
            }
        }
        return r;

    }
    _dividerName = (dividerName) => {
        return [
            <Item wrapperCol={{ span: 18, offset: 3 }}>
                <WizDivider>
                    {dividerName}
                </WizDivider>
            </Item>,
        ]
    }
    _outPutType = (outPutType, key,apiTypePathStage) => {
        let { getFieldDecorator } = this.props.form;
        let { data,form } = this.props;
        let onChangeRowMap = (dataMap, rowKey = key) => {
            if (dataMap != null) {
                let info = Object.values(dataMap).map(val => { return { id: val.id, name: val.title || val.name ,title:val.title} })
                this.setState({
                    [`output${rowKey}`]: info,
                })
                if(rowKey==99){
                    form.setFieldsValue(
                        { stageId: undefined }
                    )
                    this.setState({timeKey: new Date().getTime()})
                }
            }
        }

        let apiType = apiTypePathStage;
        let field = 'stageId';
        let entity = {};
        let selectType = 'radio'
        let entityList = [];
        if (data && data.requirementContents && data.requirementContents.length > 0) {
            data.requirementContents.forEach(element => {
                if (element.type === 0 && outPutType === '路径阶段') {
                    entity = element
                } else if (element.type === 1 && outPutType === '认证') {
                    entity = element
                } else if (element.type === 2 && outPutType === '线下课程') {
                    entity = element
                }else if (element.type === 10 && outPutType === '在线考试') {
                    entity = element
                }else if(element.type === 99 && outPutType === '路径'){
                    entity = element
                }else if(element.type === 11 && outPutType === '在线课程'){
                    entityList.push(element);
                }
            });
        }

        let initialValue = entity[`entityId`] ? entity[`entityId`] : null;
        let initRows = entity[`entityId`] ? [{ id: entity[`entityId`], name: entity[`entityName`] ,title: entity[`entityName`]}] : [];
        if(entityList.length){
            initRows = [];
            initialValue = [];
            entityList.forEach(e=>{
                initialValue.push(e[`entityId`]);
                initRows.push({ id: e[`entityId`], name: e[`entityName`] ,title: e[`entityName`]})
            })
        }
        
        if (outPutType === '认证') {
            apiType = cert;
            field = 'certId';
        } else if (outPutType === '线下课程') {
            apiType = offlineProgram;
            field = 'offlineProgramId';
        }else if (outPutType === '在线考试') {
            apiType = exam;
            field = 'examId';
        }else if(outPutType === '路径'){
            apiType = path;
            field = 'pathId';
        }else if(outPutType === '在线课程'){
            apiType = onlineProgram
            field = 'onlineProgramIds'
            selectType = "checkbox"
        }
        let formKey =  entity[`entityId`] + key + "@" + this.state.date
        if(entityList.length){
            formKey =  entityList.length + key + "@" + this.state.date
        }
        if(field == 'stageId'){
            formKey= formKey +this.state.timeKey;
        }

        let wrapperColStyle = { span: 14, offset: 0}
        let labelColStyle = {span:6}
        if(field == 'pathId'){
            wrapperColStyle = { span: 12,offset: 0}
            labelColStyle = {span:12}
        }
        if(field== 'stageId'){
            wrapperColStyle = { span: 12,offset: 0}
            labelColStyle = {span:6}
        }

        let returnInfo =
            <Item label={outPutType} labelCol={labelColStyle} wrapperCol={wrapperColStyle}>
                {getFieldDecorator(field, {
                    rules: [{ required: true, message: "请选择" + outPutType }],
                    initialValue: initialValue
                })(
                    <WizTableForm
                        key={formKey}
                        {...apiType}
                        selectType={selectType}
                        initRows={ initRows}
                        onChangeRowMap={onChangeRowMap}
                    />
                )}
            </Item>
        return returnInfo;
    }
    /**
     * 设置
     */
    _extOpther = () => {
        let { getFieldDecorator } = this.props.form;
        let { data } = this.props;
        let entity = {};
        if (data && data.requirementContents && data.requirementContents.length > 0) {
            data.requirementContents.forEach(element => {
                if (element.type === 0) {
                    entity = element
                }
            });
        }
        let result = [<></>]
        result.push(
            <Item label="路径阶段考核要求">
                {getFieldDecorator('modes', {
                    rules: [{ required: true, message: "请输入路径阶段考核要求" }],
                    initialValue: entity['modes'] ? entity['modes'] : []
                })(
                    <WizCheckbox.Group>
                        <WizCheckbox value={1}>线上课程</WizCheckbox>
                        <WizCheckbox value={2}>在线考试</WizCheckbox>
                        <WizCheckbox value={3}>评语导入</WizCheckbox>
                        <WizCheckbox value={4}>线下课程</WizCheckbox>
                        <WizCheckbox value={6}>课程组</WizCheckbox>
                        <WizCheckbox value={7}>资讯</WizCheckbox>
                        <WizCheckbox value={8}>作业</WizCheckbox>
                    </WizCheckbox.Group>,
                )}
            </Item>)

        return result
    }

    /**
    * 处理表单提交事件
    */
    handleSubmit = e => {
        let { submit } = this.props;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                submit && submit(values)
            }
        });
    };

    render() {
        let type = this.props.form.getFieldValue("type")
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        return (
            <WizForm
                {...formItemLayout}
                onSubmit={this.handleSubmit}
            >
                {this._base()}
                {this._ext(type)}
                {this._submit()}
            </WizForm>
        )
    }
}

export default WizForm.create()(RequirementForm);

/**
 * 默认值
 */
RequirementForm.defaultProps = {
    // title: '新增题目',
    data: {},
    selects: []
}

/**
 * props入参校验
 */
RequirementForm.propTypes = {
}

